import { Text, View } from '@react-pdf/renderer';
import { cellPdf, stylesPdf } from '../../../pdfs';

export const fieldsBoletinPdf = (bloques) => (
  <View style={stylesPdf.row}>
    {cellPdf({
      value: 'ÁREAS DE FORMACIÓN',
      width: '45%',
      stylesText: stylesPdf.title,
    })}
    {bloques.map((bloque) =>
      cellPdf({
        value: bloque.abrev,
        width: '8%',
        bold: true,
        stylesText: stylesPdf.text,
      }),
    )}
    {cellPdf({
      value: 'DEF.',
      width: '10%',
      stylesText: stylesPdf.title,
    })}
    {cellPdf({
      value: 'INAS.',
      width: '10%',
      stylesText: stylesPdf.title,
    })}
    {cellPdf({
      value: 'ASIS.',
      width: '10%',
      stylesText: stylesPdf.title,
    })}
    <View
      style={[
        stylesPdf.cell,
        {
          borderTopWidth: 0,
          width: '30%',
        },
      ]}
    >
      <Text style={stylesPdf.title}>SELLO</Text>
    </View>
  </View>
);

export const dataBoletinPdf = (id, materia, max, asistencia) => (
  <View style={stylesPdf.row}>
    {cellPdf({
      value: materia.nombre,
      width: '45%',
      textAlign: 'left',
      stylesText: stylesPdf.text,
    })}
    {materia.bloques.map((bloque) =>
      cellPdf({
        value: `${bloque.nota}`,
        width: '8%',
        stylesText: {
          ...stylesPdf.text,
          fontSize: '10pt',
        },
      }),
    )}
    {cellPdf({
      value: materia.definitiva,
      width: '10%',
      stylesText: {
        ...stylesPdf.text,
        fontSize: '10pt',
      },
    })}
    {cellPdf({
      value: asistencia.inasGeneral,
      width: '10%',
      stylesText: {
        ...stylesPdf.text,
        fontSize: '10pt',
      },
    })}
    {cellPdf({
      value: asistencia.asisGeneral,
      width: '10%',
      stylesText: {
        ...stylesPdf.text,
        fontSize: '10pt',
      },
    })}
    <View
      style={[
        {
          borderTopWidth: 0,
          borderRightWidth: 1,
          borderLeftWidth: 1,
          borderBottomWidth: max ? 1 : 0,
          width: '30%',
        },
      ]}
    ></View>
  </View>
);

const NotasDefinitivasPdf = ({ bloques, estudiante }) => {
  return (
    <View style={stylesPdf.section}>
      <View
        style={[
          stylesPdf.cell,
          {
            borderTopWidth: 0,
            paddingBottom: 2,
          },
        ]}
      >
        <Text style={stylesPdf.title}>CALIFICACIONES</Text>
      </View>
      {fieldsBoletinPdf(bloques)}
      {estudiante.materias.map((materia, index) => {
        const asistencia = estudiante.asistencias.find(
          (as) => as.id === materia.id,
        );

        return dataBoletinPdf(
          index,
          materia,
          index === estudiante.materias.length - 1,
          asistencia,
        );
      })}
    </View>
  );
};

export default NotasDefinitivasPdf;
